import { Model } from '../parents/model';

export class OrderCreditModel extends Model {
  static ATTR_ID = 'id';
  static ATTR_TAXED_PRICE = 'taxed_price';
  static ATTR_BANK_ACCOUNT_IBAN = 'bank_account_iban';
  static ATTR_BANK_ACCOUNT_NUMBER = 'bank_account_number';
  static ATTR_BANK_CODE = 'bank_code';
  static ATTR_BANK_SWIFT_CODE = 'bank_swift_code';
  static ATTR_COMPLAINT_ID = 'complaint_id';
  static ATTR_CREATED_AT = 'created_at';
  static ATTR_CURRENCY_ID = 'currency_id';
  static ATTR_CUSTOMER_ID = 'customer_id';
  static ATTR_EMAIL = 'email';
  static ATTR_HAS_SHIPPING_ADDRESS = 'has_shipping_address';
  static ATTR_LANGUAGE_ID = 'language_id';
  static ATTR_ORDER_ID = 'order_id';
  static ATTR_ORDER_INVOICE_ID = 'order_invoice_id';
  static ATTR_PRICE = 'price';
  static ATTR_STATE = 'state';
  static ATTR_UPDATED_AT = 'updated_at';
  static ATTR_USER_ID = 'user_id';

  static EMBEDS_ORDER_INVOICE = 'order_invoice';
  static EMBEDS_CUSTOMER_NAME = 'customer_name';
  static EMBEDS_CREDIT_INVOICES = 'credit_invoices';
  static EMBEDS_ITEMS_PRICE = 'items_price';
  static EMBEDS_PAYMENT_METHOD = 'payment_method';
  static EMBEDS_TAX_AMOUNT = 'tax_amount';
  static EMBEDS_TAXED_ITEMS_PRICE = 'taxed_items_price';
  static EMBEDS_USER = 'user';

  get id() {
    return this.attributes[OrderCreditModel.ATTR_ID];
  }

  get taxed_price() {
    return this.attributes[OrderCreditModel.ATTR_TAXED_PRICE];
  }

  get bank_account_iban() {
    return this.attributes[OrderCreditModel.ATTR_BANK_ACCOUNT_IBAN];
  }

  get bank_account_number() {
    return this.attributes[OrderCreditModel.ATTR_BANK_CODE];
  }

  get bank_code() {
    return this.attributes[OrderCreditModel.ATTR_TAXED_PRICE];
  }

  get bank_swift_code() {
    return this.attributes[OrderCreditModel.ATTR_BANK_SWIFT_CODE];
  }

  get complaint_id() {
    return this.attributes[OrderCreditModel.ATTR_COMPLAINT_ID];
  }

  get created_at() {
    return this.attributes[OrderCreditModel.ATTR_CREATED_AT];
  }

  get currency_id() {
    return this.attributes[OrderCreditModel.ATTR_CURRENCY_ID];
  }

  get customer_id() {
    return this.attributes[OrderCreditModel.ATTR_CUSTOMER_ID];
  }

  get email() {
    return this.attributes[OrderCreditModel.ATTR_EMAIL];
  }

  get has_shipping_address() {
    return this.attributes[OrderCreditModel.ATTR_HAS_SHIPPING_ADDRESS];
  }

  get language_id() {
    return this.attributes[OrderCreditModel.ATTR_LANGUAGE_ID];
  }

  get order_id() {
    return this.attributes[OrderCreditModel.ATTR_ORDER_ID];
  }

  get order_invoice_id() {
    return this.attributes[OrderCreditModel.ATTR_ORDER_INVOICE_ID];
  }

  get price() {
    return this.attributes[OrderCreditModel.ATTR_PRICE];
  }

  get state() {
    return this.attributes[OrderCreditModel.ATTR_STATE];
  }

  get updated_at() {
    return this.attributes[OrderCreditModel.ATTR_UPDATED_AT];
  }

  get user_id() {
    return this.attributes[OrderCreditModel.ATTR_USER_ID];
  }

  get order_invoice() {
    return this.embeds[OrderCreditModel.EMBEDS_ORDER_INVOICE];
  }

  get customer_name() {
    return this.embeds[OrderCreditModel.EMBEDS_CUSTOMER_NAME];
  }

  get credit_invoices() {
    return this.embeds[OrderCreditModel.EMBEDS_CREDIT_INVOICES];
  }

  get items_price() {
    return this.embeds[OrderCreditModel.EMBEDS_ITEMS_PRICE];
  }

  get payment_method() {
    return this.embeds[OrderCreditModel.EMBEDS_PAYMENT_METHOD];
  }

  get tax_amount() {
    return this.embeds[OrderCreditModel.EMBEDS_TAX_AMOUNT];
  }

  get taxed_items_price() {
    return this.embeds[OrderCreditModel.EMBEDS_TAXED_ITEMS_PRICE];
  }

  get user() {
    return this.embeds[OrderCreditModel.EMBEDS_USER];
  }
}
